// Mock data for TechInstall Pro website

// Cartes tarifaires partagées (identiques sur toutes les pages service)
const mainOeuvreCard = {
  name: "Main d'œuvre",
  items: [
    { label: "Journée", value: "400 € HT" },
    { label: "Demi-journée", value: "230 € HT" }
  ]
};

const fraisDeplacementCard = {
  name: "Frais de déplacement",
  items: [
    { label: "Jusqu'à 20 km", value: "Offert" },
    { label: "20 à 40 km", value: "25 € HT" },
    { label: "40 à 60 km", value: "45 € HT" },
    { label: "60 à 80 km", value: "65 € HT" },
    { label: "Au-delà de 80 km", value: "Sur devis" }
  ],
  note: "Calculés au départ de Lyon. Déplacement offert pour toute journée réservée (dans la limite de 100 km)."
};

export const services = [
  {
    id: 1,
    slug: "installation-pc",
    icon: "Monitor",
    title: "Installation PC",
    description: "Configuration complète de postes de travail, installation des logiciels nécessaires et optimisation des performances pour votre productivité.",
    features: ["Assemblage et configuration", "Installation logiciels", "Optimisation système"],
    color: "bg-blue-100",
    iconColor: "text-blue-500",
    borderColor: "border-l-blue-500",
    bgGradient: "from-blue-500 to-blue-600",
    priceSummary: [
      "PC neuf dès 879 € HT",
      "PC reconditionné possible",
      "Main-d'œuvre dès 230 € HT"
    ],
    // Détails étendus pour la page service
    fullDescription: "Notre service d'installation PC offre une solution complète pour équiper votre entreprise avec des postes de travail performants et parfaitement configurés. Nous vous accompagnons avant tout dans le choix du meilleur matériel selon vos besoins réels et votre budget : nous proposons des PC pour tous les budgets et pouvons également vous fournir du matériel reconditionné, fiable et garanti, si vous le souhaitez. De l'assemblage à l'installation des logiciels métiers, nous prenons en charge l'intégralité du processus pour vous garantir des équipements prêts à l'emploi.",
    detailedFeatures: [
      {
        title: "Conseil et choix du matériel",
        description: "Nous vous aidons à choisir le meilleur matériel selon vos besoins et votre budget. Des PC pour tous les budgets, avec la possibilité de matériel reconditionné fiable et garanti."
      },
      {
        title: "Assemblage et configuration matérielle",
        description: "Montage professionnel de vos PC, configuration du BIOS, installation des composants et tests de stabilité."
      },
      {
        title: "Installation du système d'exploitation",
        description: "Installation et activation de Windows 10/11 Pro, configuration des comptes utilisateurs et des paramètres de sécurité."
      },
      {
        title: "Installation des logiciels métiers",
        description: "Mise en place de votre suite bureautique (Microsoft 365, LibreOffice), logiciels de comptabilité, CRM et autres outils spécifiques."
      },
      {
        title: "Optimisation des performances",
        description: "Configuration des paramètres système pour des performances optimales, désactivation des services inutiles, optimisation du démarrage."
      },
      {
        title: "Intégration réseau",
        description: "Connexion au réseau d'entreprise, configuration des partages de fichiers et des imprimantes réseau."
      }
    ],
    pricing: [
      mainOeuvreCard,
      {
        name: "Achat de PC",
        items: [
          { label: "PC neuf", value: "dès 879 € HT" },
          { label: "PC reconditionné", value: "moins cher" }
        ],
        note: "Nous pouvons aussi fournir du matériel reconditionné, fiable et garanti, pour réduire votre budget."
      },
      fraisDeplacementCard
    ],
    faq: [
      { question: "Combien de temps faut-il pour installer et configurer un PC professionnel ?", answer: "La durée dépend de la configuration du poste et des logiciels à installer. Une installation classique comprend la mise en service du PC, la configuration de Windows, la création des comptes utilisateurs, l'installation des logiciels et la connexion au réseau. Pour plusieurs postes ou une configuration plus complexe, un délai supplémentaire peut être nécessaire." },
      { question: "Pouvez-vous fournir un PC adapté à mes besoins ?", answer: "Oui. Nous pouvons vous conseiller et vous fournir un PC neuf ou reconditionné en fonction de votre activité, de vos besoins techniques et de votre budget. Le matériel reconditionné peut notamment permettre de réduire le coût d'équipement tout en bénéficiant d'un matériel fiable et garanti." }
    ],
    image: "/images/service-pc-install.jpg"
  },
  {
    id: 2,
    slug: "installation-imprimantes",
    icon: "Printer",
    title: "Installation Imprimantes",
    description: "Installation et configuration d'imprimantes réseau, mise en place des pilotes et paramétrage pour une impression optimale.",
    features: ["Configuration réseau", "Installation pilotes", "Partage multi-utilisateurs"],
    color: "bg-purple-100",
    iconColor: "text-purple-500",
    borderColor: "border-l-purple-500",
    bgGradient: "from-purple-500 to-purple-600",
    priceSummary: [
      "Imprimante pro laser dès 230 € HT",
      "Matériel reconditionné possible",
      "Main-d'œuvre dès 230 € HT"
    ],
    fullDescription: "Simplifiez votre gestion documentaire avec notre service d'installation d'imprimantes professionnelles. Nous configurons vos imprimantes pour un fonctionnement optimal en réseau, permettant à tous vos collaborateurs d'imprimer facilement et en toute sécurité.",
    detailedFeatures: [
      {
        title: "Installation physique",
        description: "Déballage, mise en place et connexion de l'imprimante (USB, Ethernet ou WiFi) selon votre configuration."
      },
      {
        title: "Configuration réseau",
        description: "Attribution d'une adresse IP fixe, configuration des paramètres réseau pour une connexion stable."
      },
      {
        title: "Installation des pilotes",
        description: "Installation des pilotes sur tous les postes concernés, configuration des préférences d'impression par défaut."
      },
      {
        title: "Partage multi-utilisateurs",
        description: "Configuration du partage d'imprimante pour permettre l'accès à tous les utilisateurs autorisés."
      },
      {
        title: "Configuration avancée",
        description: "Paramétrage des fonctions avancées : scan vers email, numérisation réseau, impression recto-verso automatique."
      },
      {
        title: "Formation utilisateurs",
        description: "Explication des fonctionnalités de base et avancées à vos équipes."
      }
    ],
    pricing: [
      mainOeuvreCard,
      {
        name: "Achat imprimante",
        items: [
          { label: "Imprimante pro laser", value: "dès 230 € HT" }
        ],
        note: "Possibilité de matériel reconditionné, fiable et garanti."
      },
      fraisDeplacementCard
    ],
    faq: [
      { question: "Quelles marques d'imprimantes pouvez-vous installer ?", answer: "Nous pouvons installer et configurer la plupart des imprimantes professionnelles courantes, qu'elles soient connectées en USB, Ethernet ou Wi-Fi. Avant l'intervention, nous vérifions la compatibilité du matériel avec votre environnement informatique." },
      { question: "Pouvez-vous configurer la numérisation vers une adresse e-mail ?", answer: "Oui. Lorsque l'imprimante ou le multifonction le permet, nous pouvons configurer la fonction de numérisation vers une adresse e-mail ainsi que d'autres fonctions de numérisation réseau." },
      { question: "Pouvez-vous intervenir si mon imprimante tombe en panne ?", answer: "Oui. Nous pouvons effectuer un diagnostic afin d'identifier l'origine du problème. Selon la nature de la panne, nous pouvons intervenir sur la configuration, les pilotes ou les problèmes liés à votre environnement informatique. Pour une panne matérielle nécessitant une réparation spécifique, nous vous indiquons la solution la plus adaptée." }
    ],
    image: "/images/service-printer.jpg"
  },
  {
    id: 3,
    slug: "telephonie-ip",
    icon: "Phone",
    title: "Téléphonie IP",
    description: "Déploiement de solutions de téléphonie IP modernes pour une communication professionnelle efficace et économique.",
    features: ["Installation téléphones IP", "Configuration VOIP", "Tests de qualité"],
    color: "bg-green-100",
    iconColor: "text-green-500",
    borderColor: "border-l-green-500",
    bgGradient: "from-green-500 to-green-600",
    priceSummary: [
      "Ex. : 1 poste d'accueil + 4 DECT dès 599 € HT",
      "Abonnement 15 € HT/mois par téléphone"
    ],
    fullDescription: "Modernisez vos communications avec notre service de téléphonie IP. Réduisez vos coûts téléphoniques tout en bénéficiant de fonctionnalités avancées : messagerie vocale, transfert d'appels, conférences téléphoniques et bien plus encore.",
    detailedFeatures: [
      {
        title: "Audit des besoins",
        description: "Analyse de vos besoins en communication, évaluation de votre infrastructure réseau existante."
      },
      {
        title: "Installation des téléphones IP",
        description: "Mise en place et configuration des postes téléphoniques IP (Yealink, Cisco, Grandstream, etc.)."
      },
      {
        title: "Configuration du standard",
        description: "Paramétrage du standard téléphonique virtuel, création des extensions, groupes d'appels."
      },
      {
        title: "Messagerie vocale",
        description: "Configuration des messageries vocales individuelles et de groupe, notification par email."
      },
      {
        title: "Fonctionnalités avancées",
        description: "Mise en place du transfert d'appels, de la mise en attente musicale, des conférences téléphoniques."
      },
      {
        title: "Formation des utilisateurs",
        description: "Formation de vos équipes à l'utilisation du standard téléphonique et de ses fonctionnalités."
      }
    ],
    pricing: [
      mainOeuvreCard,
      {
        name: "Standard & abonnement",
        items: [
          { label: "Exemple : 1 poste d'accueil + 4 DECT", value: "dès 599 € HT" },
          { label: "Abonnement / téléphone", value: "15 € HT/mois" }
        ],
        note: "Exemple de configuration correspondant au tarif indiqué. Abonnement mensuel par téléphone pouvant recevoir des appels depuis l'extérieur."
      },
      fraisDeplacementCard
    ],
    faq: [
      { question: "Quels sont les avantages de la téléphonie IP pour une entreprise ?", answer: "La téléphonie IP permet de gérer les communications professionnelles via votre connexion Internet. Elle offre notamment des fonctionnalités comme le transfert d'appels, les groupes d'appels, la messagerie vocale et les conférences téléphoniques. Elle peut également simplifier la gestion de plusieurs postes au sein d'une entreprise." },
      { question: "Ma connexion Internet est-elle suffisamment performante pour utiliser la téléphonie IP ?", answer: "Une connexion Internet stable et suffisamment performante est nécessaire pour garantir une bonne qualité d'appel. Nous pouvons vérifier votre infrastructure réseau et vos besoins avant l'installation afin de déterminer si votre connexion actuelle est adaptée." },
      { question: "Puis-je conserver mon numéro de téléphone actuel ?", answer: "Dans de nombreux cas, il est possible de conserver un numéro existant grâce à la portabilité. La faisabilité dépend toutefois de votre opérateur et de votre situation. Nous pouvons vous accompagner dans la mise en place de la solution de téléphonie IP et vous indiquer les démarches nécessaires." }
    ],
    image: "/images/service-telephony-reception.jpg"
  },
  {
    id: 4,
    slug: "mise-en-reseau",
    icon: "Network",
    title: "Mise en Réseau",
    description: "Création et optimisation de réseaux locaux sécurisés pour connecter tous vos équipements efficacement.",
    features: ["Raccordement & brassage", "Configuration routeurs", "Sécurisation réseau"],
    color: "bg-orange-100",
    iconColor: "text-orange-500",
    borderColor: "border-l-orange-500",
    bgGradient: "from-orange-500 to-orange-600",
    priceSummary: [
      "Configuration minimale dès 420 € HT (switch + routeur)",
      "Baie de brassage dès 150 € HT",
      "Onduleur dès 130 € HT"
    ],
    fullDescription: "Un réseau performant est la colonne vertébrale de votre entreprise. Notre service de mise en réseau vous garantit une infrastructure stable, sécurisée et évolutive pour supporter toutes vos activités numériques. LYNKO assure également le raccordement des postes informatiques et équipements à la baie réseau, ainsi que le brassage et la configuration des ports réseau. Le passage et la création du câblage dans les murs, plafonds ou cloisons ne sont pas inclus et peuvent être réalisés par un électricien ou un professionnel du câblage.",
    detailedFeatures: [
      {
        title: "Étude et conception",
        description: "Analyse de vos locaux et besoins, conception d'une architecture réseau adaptée."
      },
      {
        title: "Raccordement réseau & brassage",
        description: "Raccordement des ordinateurs, imprimantes, téléphones et équipements réseau à la baie et au switch, brassage et configuration des ports."
      },
      {
        title: "Configuration routeurs et switchs",
        description: "Installation et paramétrage des équipements réseau (routeurs, switchs, points d'accès WiFi)."
      },
      {
        title: "Réseau WiFi professionnel",
        description: "Déploiement d'un réseau WiFi sécurisé avec couverture optimale de vos locaux."
      },
      {
        title: "Sécurisation réseau",
        description: "Configuration du pare-feu, segmentation réseau (VLAN), mise en place d'un VPN si nécessaire."
      },
      {
        title: "Documentation et support",
        description: "Remise d'une documentation complète de votre infrastructure, support post-installation."
      }
    ],
    pricing: [
      mainOeuvreCard,
      {
        name: "Configuration & équipements",
        items: [
          { label: "Configuration minimale (switch + routeur)", value: "dès 420 € HT" },
          { label: "Baie de brassage", value: "dès 150 € HT" },
          { label: "Onduleur", value: "à partir de 130 € HT" }
        ]
      },
      fraisDeplacementCard
    ],
    faq: [
      { question: "Est-il préférable d'utiliser un réseau filaire ou le Wi-Fi ?", answer: "Les deux solutions peuvent être complémentaires. Le réseau filaire offre généralement une connexion plus stable et adaptée aux postes fixes, aux serveurs et aux équipements professionnels. Le Wi-Fi apporte davantage de souplesse pour les ordinateurs portables, smartphones et autres appareils mobiles. Nous pouvons vous conseiller une installation adaptée à vos locaux et à vos usages." },
      { question: "Comment sécurisez-vous le réseau de mon entreprise ?", answer: "La sécurisation peut notamment comprendre la configuration du routeur et du pare-feu, la mise en place d'un réseau Wi-Fi sécurisé, la séparation des différents réseaux et, lorsque cela est nécessaire, la mise en place d'un VPN. Les mesures retenues dépendent de votre infrastructure et de vos besoins." }
    ],
    image: "/images/service-network.jpg"
  },
  {
    id: 5,
    slug: "depannage-support",
    icon: "Wrench",
    title: "Dépannage & Support",
    description: "Intervention rapide en cas de problème informatique pour minimiser les interruptions de votre activité.",
    features: ["Diagnostic rapide", "Réparation sur site", "Assistance téléphonique"],
    color: "bg-red-100",
    iconColor: "text-red-500",
    borderColor: "border-l-red-500",
    bgGradient: "from-red-500 to-red-600",
    priceSummary: [
      "À distance : 50 € HT/h (30 min min.)",
      "Sur site : 80 € HT/h + déplacement",
      "Contrat support sur devis"
    ],
    fullDescription: "Un problème informatique peut paralyser votre activité. Notre service de dépannage vous garantit une intervention rapide et efficace pour résoudre tous vos incidents techniques et vous remettre en selle au plus vite.",
    detailedFeatures: [
      {
        title: "Diagnostic à distance",
        description: "Première analyse du problème par téléphone ou prise en main à distance pour les incidents simples."
      },
      {
        title: "Intervention sur site",
        description: "Déplacement rapide dans vos locaux pour les problèmes nécessitant une intervention physique."
      },
      {
        title: "Dépannage matériel",
        description: "Diagnostic et réparation des pannes matérielles : PC qui ne démarre plus, écran noir, surchauffe, etc."
      },
      {
        title: "Dépannage logiciel",
        description: "Résolution des problèmes Windows, virus, logiciels qui plantent, lenteurs système."
      },
      {
        title: "Récupération de données",
        description: "Tentative de récupération de vos données en cas de panne de disque dur ou suppression accidentelle."
      },
      {
        title: "Assistance téléphonique",
        description: "Support par téléphone pour vous guider dans la résolution de problèmes simples."
      }
    ],
    pricing: [
      {
        name: "Contrat support",
        price: "Sur devis",
        description: "Support à distance illimité + priorité"
      },
      {
        name: "Interventions",
        items: [
          { label: "Intervention à distance", value: "50 € HT/h" },
          { label: "Intervention physique", value: "80 € HT/h" }
        ],
        note: "Intervention à distance : 30 minutes minimum. Intervention physique : coût du déplacement en sus."
      },
      fraisDeplacementCard
    ],
    faq: [
      { question: "Dans quel délai pouvez-vous intervenir en cas de problème informatique ?", answer: "Nous faisons notre possible pour intervenir rapidement afin de limiter l'impact d'une panne sur votre activité. Le délai dépend notamment de l'urgence, de la nature du problème et de votre localisation. Un premier diagnostic peut également être réalisé à distance pour certains incidents." },
      { question: "Pouvez-vous résoudre un problème informatique à distance ?", answer: "Oui. Lorsque le problème ne nécessite pas d'intervention physique, nous pouvons effectuer un diagnostic et, lorsque cela est possible, intervenir à distance. Cela permet notamment de résoudre rapidement certains problèmes logiciels, de configuration ou d'utilisation." },
      { question: "Que se passe-t-il si le problème ne peut pas être réparé immédiatement ?", answer: "Nous commençons par établir un diagnostic afin d'identifier l'origine du problème et les solutions possibles. Si une réparation immédiate n'est pas possible, nous vous expliquons la situation et vous proposons une solution adaptée : remplacement d'un composant, intervention complémentaire, récupération de données ou remplacement du matériel selon le cas." }
    ],
    image: "/images/service-support.jpg"
  },
  {
    id: 6,
    slug: "maintenance-preventive",
    icon: "Shield",
    title: "Maintenance et Sécurité",
    description: "Contrats de maintenance pour assurer la pérennité et la performance de votre infrastructure informatique.",
    features: ["Vérifications régulières", "Mises à jour système", "Optimisation continue"],
    color: "bg-indigo-100",
    iconColor: "text-indigo-500",
    borderColor: "border-l-indigo-500",
    bgGradient: "from-indigo-500 to-indigo-600",
    priceSummary: [
      "25 € HT / poste / mois",
      "Surveillance & mises à jour incluses"
    ],
    fullDescription: "Prévenir vaut mieux que guérir. Notre service de maintenance assure le bon fonctionnement continu de votre parc informatique grâce à des interventions régulières et planifiées, évitant ainsi les pannes coûteuses.",
    detailedFeatures: [
      {
        title: "Audit initial",
        description: "État des lieux complet de votre parc informatique, identification des points d'amélioration."
      },
      {
        title: "Mises à jour système",
        description: "Application régulière des mises à jour Windows, pilotes et logiciels pour la sécurité et les performances."
      },
      {
        title: "Vérification matérielle",
        description: "Contrôle de l'état des composants, nettoyage des poussières, vérification des températures."
      },
      {
        title: "Optimisation des performances",
        description: "Nettoyage des fichiers temporaires, défragmentation, optimisation du démarrage."
      },
      {
        title: "Surveillance et sécurité",
        description: "Surveillance proactive de votre parc informatique, contrôle des mises à jour de sécurité et détection des anomalies afin de limiter les risques et les interruptions."
      },
      {
        title: "Rapport de maintenance",
        description: "Compte-rendu détaillé après chaque intervention avec recommandations."
      }
    ],
    pricing: [
      mainOeuvreCard,
      {
        name: "Maintenance",
        price: "25 € HT / poste / mois",
        description: "Maintenance et sécurité de votre parc informatique"
      },
      fraisDeplacementCard
    ],
    faq: [
      { question: "À quelle fréquence faut-il effectuer la maintenance informatique ?", answer: "La fréquence dépend de la taille de votre parc, du nombre de postes et de votre utilisation. Nos contrats prévoient notamment des interventions trimestrielles ou mensuelles selon la formule choisie. L'objectif est de vérifier régulièrement l'état du matériel, les mises à jour, les sauvegardes et les éléments de sécurité." },
      { question: "La maintenance préventive comprend-elle également le dépannage ?", answer: "La maintenance préventive a pour objectif de réduire les risques de panne grâce à des contrôles et des actions régulières. Le dépannage d'une panne ponctuelle n'est pas nécessairement inclus dans toutes les formules. Les conditions dépendent du contrat de maintenance choisi. Nous pouvons vous préciser ce qui est inclus dans votre formule avant sa mise en place." },
      { question: "Puis-je résilier mon contrat de maintenance ?", answer: "Les modalités de résiliation dépendent des conditions prévues dans le contrat souscrit. Nous vous indiquons clairement les conditions applicables avant la signature afin que vous sachiez notamment quelle est la durée d'engagement et quel est le délai de préavis éventuel." }
    ],
    image: "/images/service-maintenance.jpg"
  },
  {
    id: 7,
    slug: "sauvegarde-donnees",
    icon: "Database",
    title: "Sauvegarde & Protection des Données",
    description: "Mise en place de solutions de sauvegarde automatiques et sécurisées pour protéger les données vitales de votre entreprise.",
    features: ["Sauvegardes automatiques", "Stockage local & cloud", "Protection anti-ransomware"],
    color: "bg-cyan-100",
    iconColor: "text-cyan-500",
    borderColor: "border-l-cyan-500",
    bgGradient: "from-cyan-500 to-cyan-600",
    priceSummary: [
      "Solution sur devis",
      "Locale, cloud ou hybride"
    ],
    fullDescription: "Une panne, un vol ou un rançongiciel peut anéantir des années de travail. Notre service de sauvegarde et protection des données met en place une stratégie complète et automatique pour que vos fichiers, dossiers clients et données comptables soient toujours récupérables, quoi qu'il arrive.",
    detailedFeatures: [
      {
        title: "Audit de vos données",
        description: "Identification des données critiques, de leur emplacement et de leur volume pour définir la stratégie de sauvegarde adaptée."
      },
      {
        title: "Sauvegarde locale",
        description: "Mise en place d'un serveur de sauvegarde ou NAS sur site, avec copie automatique et versionning de vos fichiers."
      },
      {
        title: "Sauvegarde cloud",
        description: "Réplication chiffrée de vos données vers un cloud sécurisé pour vous protéger même en cas de sinistre physique."
      },
      {
        title: "Protection anti-ransomware",
        description: "Sauvegardes hors ligne ou immuables, durcissement des accès et bonnes pratiques pour limiter l'impact des attaques."
      },
      {
        title: "Plan de reprise d'activité",
        description: "Procédures documentées pour restaurer rapidement vos données et redémarrer votre activité après un incident."
      },
      {
        title: "Tests de restauration",
        description: "Vérifications régulières que vos sauvegardes sont bien exploitables : une sauvegarde non testée n'est pas une sauvegarde."
      }
    ],
    pricing: [
      mainOeuvreCard,
      {
        name: "Solution de sauvegarde",
        price: "Sur devis",
        description: "Selon le volume de données et le niveau de protection souhaité"
      },
      fraisDeplacementCard
    ],
    faq: [
      { question: "Pourquoi est-il important de sauvegarder les données de mon entreprise ?", answer: "Une panne informatique, une erreur de manipulation, un vol ou une attaque informatique peuvent entraîner la perte de données importantes. Une solution de sauvegarde permet de conserver des copies de vos fichiers et de les restaurer en cas de problème." },
      { question: "Où sont stockées les sauvegardes de mes données ?", answer: "Les sauvegardes peuvent être stockées sur différents supports ou emplacements selon vos besoins : serveur, disque de sauvegarde ou stockage distant. Nous pouvons vous conseiller une solution permettant de limiter les risques liés à la perte ou à la défaillance d'un équipement." },
      { question: "Comment savoir si mes sauvegardes fonctionnent correctement ?", answer: "Une sauvegarde n'est utile que si les données peuvent être restaurées. Nous pouvons contrôler le bon fonctionnement de vos sauvegardes et vérifier régulièrement que vos données sont correctement enregistrées et récupérables." }
    ],
    image: "/images/service-backup.jpg"
  },
  {
    id: 8,
    slug: "creation-site-web",
    icon: "Globe",
    title: "Création de Sites Web",
    description: "Création de sites web professionnels, rapides et optimisés pour le référencement, à l'image de votre entreprise.",
    features: ["Site vitrine clé en main", "Optimisé SEO", "Design responsive"],
    color: "bg-rose-100",
    iconColor: "text-rose-500",
    borderColor: "border-l-rose-500",
    bgGradient: "from-rose-500 to-rose-600",
    priceSummary: [
      "Site vitrine dès 750 € HT",
      "Site simple, clé en main"
    ],
    fullDescription: "Votre site web est votre vitrine ouverte 24h/24. Nous créons des sites professionnels modernes, rapides et optimisés pour le référencement, qui présentent votre activité, rassurent vos prospects et génèrent des demandes de contact.",
    detailedFeatures: [
      {
        title: "Analyse de vos besoins",
        description: "Définition ensemble de vos objectifs, de votre contenu et de l'arborescence idéale pour votre activité."
      },
      {
        title: "Design sur mesure",
        description: "Création d'une identité visuelle cohérente avec votre image : couleurs, typographie, mise en page."
      },
      {
        title: "Développement du site",
        description: "Réalisation d'un site rapide, sécurisé et parfaitement adapté aux mobiles, tablettes et ordinateurs."
      },
      {
        title: "Optimisation SEO",
        description: "Structure, balises et contenus optimisés pour être bien référencé sur Google dès la mise en ligne."
      },
      {
        title: "Mise en ligne & hébergement",
        description: "Configuration du nom de domaine, de l'hébergement, du certificat SSL et des adresses e-mail professionnelles."
      },
      {
        title: "Formation & suivi",
        description: "Prise en main de votre site et accompagnement après la mise en ligne pour vos premières évolutions."
      }
    ],
    pricing: [
      mainOeuvreCard,
      {
        name: "Site vitrine",
        price: "À partir de 750 € HT",
        description: "Site vitrine simple, clé en main"
      },
      fraisDeplacementCard
    ],
    faq: [
      { question: "Quel type de site web pouvez-vous créer ?", answer: "Nous créons principalement des sites vitrines permettant aux entreprises, artisans et professionnels de présenter leur activité, leurs services et leurs coordonnées. Le site peut être adapté à votre image et aux besoins spécifiques de votre activité." },
      { question: "Mon site sera-t-il adapté aux smartphones et aux tablettes ?", answer: "Oui. Le site est conçu pour s'adapter aux différentes tailles d'écran afin que vos visiteurs puissent le consulter facilement depuis un ordinateur, une tablette ou un smartphone." },
      { question: "Pourrai-je modifier moi-même le contenu de mon site ?", answer: "Selon la solution utilisée, vous pourrez modifier certains contenus de votre site, comme les textes, les images ou les actualités. Nous pouvons également vous accompagner dans la prise en main et la gestion de votre site après sa mise en ligne." }
    ],
    image: "/images/service-web.jpg"
  }
];

export const benefits = [
  {
    id: 1,
    icon: "Clock",
    title: "Intervention Rapide",
    description: "Réponse sous 24h et intervention dans les meilleurs délais",
    bgColor: "bg-blue-50",
    iconBgColor: "bg-blue-100",
    iconColor: "text-blue-500"
  },
  {
    id: 2,
    icon: "Euro",
    title: "Tarifs Compétitifs",
    description: "Prix transparents et adaptés aux budgets des TPE/PME",
    bgColor: "bg-green-50",
    iconBgColor: "bg-green-100",
    iconColor: "text-green-500"
  },
  {
    id: 3,
    icon: "UserCheck",
    title: "Service Personnalisé",
    description: "Écoute attentive et solutions sur mesure pour chaque client",
    bgColor: "bg-pink-50",
    iconBgColor: "bg-pink-100",
    iconColor: "text-pink-500"
  },
  {
    id: 4,
    icon: "Award",
    title: "Expertise Garantie",
    description: "Compétences techniques certifiées et expérience terrain",
    bgColor: "bg-orange-50",
    iconBgColor: "bg-orange-100",
    iconColor: "text-orange-500"
  }
];

export const contactInfo = {
  phone: "+33 7 49 45 13 45",
  email: "contact@lynko.info",
  hours: {
    weekdays: "Lundi - Vendredi: 9h - 18h",
    saturday: "Samedi: 9h - 12h",
    emergency: "Urgences: 6j/7"
  }
};

export const serviceOptions = [
  { value: "installation-pc", label: "Installation PC" },
  { value: "imprimantes", label: "Installation Imprimantes" },
  { value: "telephonie-ip", label: "Téléphonie IP" },
  { value: "mise-en-reseau", label: "Mise en Réseau" },
  { value: "depannage", label: "Dépannage & Support" },
  { value: "maintenance", label: "Maintenance et Sécurité" },
  { value: "sauvegarde-donnees", label: "Sauvegarde & Protection des Données" },
  { value: "creation-site-web", label: "Création de Sites Web" }
];

export const footerLinks = {
  services: [
    { label: "Installation PC", to: "/services/installation-pc" },
    { label: "Imprimantes", to: "/services/installation-imprimantes" },
    { label: "Téléphonie IP", to: "/services/telephonie-ip" },
    { label: "Mise en réseau", to: "/services/mise-en-reseau" },
    { label: "Dépannage", to: "/services/depannage-support" },
    { label: "Maintenance", to: "/services/maintenance-preventive" },
    { label: "Sauvegarde", to: "/services/sauvegarde-donnees" },
    { label: "Sites Web", to: "/services/creation-site-web" }
  ],
  quickLinks: [
    { label: "Accueil", to: "/" },
    { label: "À propos", to: "/#about" },
    { label: "Services", to: "/#services" },
    { label: "Tarifs", to: "/#tarifs" },
    { label: "Contact", to: "/contact" },
    { label: "Devis gratuit", to: "/contact" }
  ]
};
